var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ErrorLogger } from "sb-helpers";
import { DefaultError } from "../DefaultError";
/**
 * ErrorBoundary creates react component that is wrapping
 * all other components activated through BaseBlock thus giving fallback
 * from errors and hoocking up to our error logging service inside the responsive project.
 *
 * Shows {DefaultError} component if error arises.
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.logger = new ErrorLogger();
        _this.state = { error: undefined, info: undefined };
        return _this;
    }
    /**
     * Overrides inherited componentDidCatch method
     * @param {Error} error
     * @param {ErrorInfo} errorInfo
     */
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var err = { error: error, info: errorInfo };
        this.setState(err);
        this.logger.log({
            error: err.error.toString(),
            stack: err.info.componentStack
        });
    };
    ErrorBoundary.prototype.render = function () {
        return this.state.info ?
            React.createElement(DefaultError, { componentStack: this.state.info.componentStack, error: this.state.error }) :
            React.createElement("sb-comp", null, this.props.children);
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
//# sourceMappingURL=ErrorBoundary.js.map